import { ExclamationMarkIcon } from "@/components/Icons/ExclamationMarkIcon";
import { useJoinWithReferralCode } from "@roman/shared/hooks/referral/useJoinWithReferralCode";
import { useUsedReferral } from "@roman/shared/hooks/referral/useUsedReferral";
import { getAuthenticatedUser } from "@roman/shared/store/auth.store";
import { differenceInHours } from "date-fns";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { RegisterReferralButton } from "./Button";
import { ReferralSuccessModal } from "./ReferralSuccessModal";

export const ReferralRegisterPage = () => {
  const user = getAuthenticatedUser();
  const [code, setCode] = useState<string>("");
  const navigate = useNavigate();
  const [referralErrorMessage, setReferralErrorMessage] = useState<string | null>(null);
  const { data: usedReferral, mutate: getUsedReferral } = useUsedReferral(() => {
    setReferralErrorMessage("招待コードの履歴取得に失敗しました");
  });
  const { trigger: joinWithReferralCode } = useJoinWithReferralCode(() => {
    setReferralErrorMessage("無効なコードです");
  });
  const [open, setOpen] = useState(false);

  const isWithin24Hours = differenceInHours(new Date(), new Date(user.registeredAt)) < 24;

  const handleCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCode(e.currentTarget.value);
  };

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (code) {
      try {
        await joinWithReferralCode({ referralCode: code });
        const updatedReferral = await getUsedReferral();
        if (updatedReferral) {
          setOpen(true);
        }
      } catch {}
    }
  };

  return (
    <>
      <div
        className="mt-[72px] flex flex-col items-center min-h-[calc(100vh-72px)]"
        style={{
          backgroundImage: `url('/assets/bg.svg')`,
          backgroundRepeat: "repeat",
          backgroundColor: "#f5f5f5",
        }}
      >
        <div className="w-full min-h-[calc(100vh-72px)] max-w-3xl p-8 bg-white">
          {
            <div className="flex flex-col items-start gap-10 w-full">
              <div className="">
                <p className="font-semibold text-xl -tracking-[.01em] text-black">招待コードの登録</p>
              </div>

              <form onSubmit={onSubmit} className="flex flex-col items-center w-full gap-10">
                <div className="flex flex-col items-center w-full">
                  <label className="sm:w-[500px] w-full mx-8">
                    <p className="font-medium text-base text-dark-gray mb-2">招待コード</p>
                    <input
                      type="text"
                      name="code"
                      value={code}
                      disabled={!isWithin24Hours || !!usedReferral}
                      className="border border-solid border-disabled px-5 py-2.5 font-normal text-base rounded-md w-full mb-1"
                      placeholder="招待コードを入力"
                      onChange={handleCodeChange}
                    />
                    <p className="font-medium text-base text-gray">
                      ※招待コードは新規登録後24時間以内に入力する必要があります。
                    </p>
                  </label>
                  {referralErrorMessage && (
                    <div className="sm:w-[500px] flex items-start w-full gap-1 mt-1">
                      <ExclamationMarkIcon />
                      <p className="text-sm text-red">{referralErrorMessage}</p>
                    </div>
                  )}
                </div>
                <RegisterReferralButton
                  className="sm:w-[500px] mx-8"
                  disabled={!isWithin24Hours || !code || !!usedReferral}
                >
                  保存する
                </RegisterReferralButton>
              </form>
            </div>
          }
        </div>
      </div>
      <ReferralSuccessModal
        open={open}
        setOpen={(open) => {
          if (!open) {
            navigate("/");
          }
          setOpen(open);
        }}
        earnedPoints={Number(usedReferral?.earnedPoints)}
      />
    </>
  );
};
